export interface HomeReview {
  reviewer: string;
  stars: number;
  tag: string;
  body: string;
}

// 16 則真實 App/平台評價
export const homeReviews: ReadonlyArray<HomeReview> = [
  {
    reviewer: "宋小姐",
    stars: 5,
    tag: "水管漏水",
    body: "平台任用的師傅品質非常棒。報價單上的品項透明清楚。客服人員的服務效率很好。能幫我和師傅溝通報價單上的差異。感謝平台。",
  },
  {
    reviewer: "張先生",
    stars: 5,
    tag: "冷氣漏水",
    body: "非常感謝即時解決冷氣室內機漏水問題，週五晚上報修，週六一早師傅就來了。曹師傅施工專業仔細，態度親切，報價透明實在，大大推薦！平台客服人員也持續提供媒合協助與提醒，報修過程讓我非常省心放心，肯定會繼續使用「師虎來了」！",
  },
  {
    reviewer: "劉先生",
    stars: 5,
    tag: "室內油漆",
    body: "謝謝兩位師傅在天候不佳的狀況下，仍願意遠道而來現場施作，今晚冒雨前往完工地點親眼確認，施工手法細膩、品質佳，期待入住的日子到來，謝謝師傅們辛勞及師虎平台團隊在施工前中後的不停聯繫確保，謝謝！",
  },
  {
    reviewer: "邱小姐",
    stars: 5,
    tag: "更換/新作木地板",
    body: "周師傅評估作業專業，儘速配合施工作業，若有維修中額外需處理問題，仍會事前溝通確認是否有維修意願，維修後也會將施工後照片拍照確認，整體維修過程滿意，希望有機會可以再接受他們的服務。",
  },
  {
    reviewer: "柯小姐",
    stars: 5,
    tag: "局部翻新",
    body: "黃師傅溝通和服務品質都很棒，有問題隨時可以回覆，並提供解決方案，廁所防水工程的師傅超級認真負責，防水工程做得很仔細，技術一流，水電工程人員技術很強，下次如有機會會再配合，感謝黃師傅工班，感謝師虎來了平台，解決生活大小事！",
  },
  {
    reviewer: "陳先生",
    stars: 5,
    tag: "馬桶不通",
    body: "首次體驗感覺很好，師傅專業維修、報價過程透明公開，平台全程協助不僅文字溝通也用電話協助。謝謝你，師虎來了！",
  },
  {
    reviewer: "陳先生",
    stars: 5,
    tag: "水管不通",
    body: "非常 nice 的林師傅，為了延長使用壽命，還多檢測、處理流理臺下方排水孔下的管道，順便討論後續維護管理的注意重點，非常優秀的師傅，感謝師虎介紹這樣的師傅給我。",
  },
  {
    reviewer: "賴先生",
    stars: 5,
    tag: "更換燈泡/燈管",
    body: "林師傅服務態度很好，進到室內會先貼保護膜，室內裝修都可以找他！這次是換燈泡，雖然小小的工作，但是超級難拆，幸好有林師傅幫我們解決這問題～",
  },
  {
    reviewer: "蔡先生",
    stars: 5,
    tag: "更換加壓馬達（水量加大）",
    body: "莊師傅不但迅速整潔、認真負責，還主動積極針對原馬達所接電線之安全隱患提出良心建議，實屬難得、足堪嘉許。另客服王小姐的協助媒合效率高、親和力強，也是一大助力。家人們都感謝你們團隊，真是一分錢、一分貨的品質優＋速度快！",
  },
  {
    reviewer: "陳小姐",
    stars: 5,
    tag: "水管漏水",
    body: "遇到漏水問題，緊急聯絡師傅，對方晚上迅速到場，專業程度讓人印象深刻。雖然第一時間未找到漏水點，逐一說明並提供後續建議，讓人完全放心。假日願意出門服務已經難得，還能保持這樣的工作品質更是不容易。誠心五星好評！",
  },
  {
    reviewer: "浩先生",
    stars: 5,
    tag: "無下雨天花板滴水",
    body: "師傅很認真很專業，而且服務態度超級好，不僅防水抓漏的經驗十足，而且分析與講解的能力都能讓人信服。更特別的是，他所帶領的各項工程師傅都相當專業，是一個相當值得信賴的工程團隊。",
  },
  {
    reviewer: "鄧小姐",
    stars: 5,
    tag: "燈具換新",
    body: "吳師傅人很禮貌客氣，專業不馬虎，很快新的燈具已更換一新。懂得自我要求不便宜行事的專業達人。人很好，還額外幫我釘穩了廁所洗手台的木架，讓它更牢固。值得推薦。",
  },
  {
    reviewer: "趙小姐",
    stars: 5,
    tag: "更換老舊電線",
    body: "感謝沈師傅的專業協助，帶領整個施工團隊動作迅速、施工品質紮實。師傅們很用心地幫我們找到問題、提出解決方法。沈師傅很有耐心聆聽我們的需求，現場迅速調整。👍大推👍👍大推👍👍大推👍",
  },
  {
    reviewer: "王小姐",
    stars: 5,
    tag: "下雨窗框漏水",
    body: "師傅人很客氣，服務很好，做防水工程還會幫忙多做一點。而且 大熱天看蜘蛛人在外面，上上下下很辛苦，我們很感恩，遇到好廠商！",
  },
  {
    reviewer: "許小姐",
    stars: 5,
    tag: "冷氣清洗",
    body: "楊師傅很專業，清洗很認真！謝謝，讓空氣更加清爽乾淨～第一次使用師虎平台，客服服務很即時，很不錯的體驗。",
  },
  {
    reviewer: "林先生",
    stars: 5,
    tag: "下雨屋頂/壁面漏水",
    body: "曾師傅從第一次場勘，到施工完成都非常細心與周到，我們該注意提醒的都讓我們理解，也會告訴我們他發現施工周遭的狀況（不只防水抓漏），因此這次施工品質，我們非常滿意。感謝師傅與師虎的媒合。",
  },
];
